import { render, staticRenderFns } from "./tax-filter.vue?vue&type=template&id=0f3840b0&"
import script from "./tax-filter.vue?vue&type=script&lang=js&"
export * from "./tax-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports